import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
	mode: 'history',  //去掉url中的#
	routes: [{
		path: '/',
		name: 'userBind',
		component: resolve => require(['../components/view/userBind.vue'], resolve),
	}, {
		path: '/userCenter',
		name: 'userCenter',
		component: resolve => require(['../components/view/userCenter.vue'], resolve),
	}, {
		path: '/payWaterFee',
		name: 'payWaterFee',
		component: resolve => require(['../components/view/payWaterFee.vue'], resolve),
	}, {
		path: '/waterHistory',
		name: 'waterHistory',
		component: resolve => require(['../components/view/waterHistory.vue'], resolve),
	}, {
		path: '/dealDetails',
		name: 'dealDetails',
		component: resolve => require(['../components/view/dealDetails.vue'], resolve),
	}, {
		path: '/offBind',
		name: 'offBind',
		component: resolve => require(['../components/view/offBind.vue'], resolve),
	}, {
		path: '/arrearsDetails',
		name: 'arrearsDetails',
		component: resolve => require(['../components/view/arrearsDetails.vue'], resolve),
	}, {
		path: '/HelloWorld',
		name: 'HelloWorld',
		component: resolve => require(['../components/HelloWorld.vue'], resolve),
	}, {
		path: '/payok',
		name: 'payok',
		component: resolve => require(['../components/view/payok.vue'], resolve),
	}, {
		path: '/payfail',
		name: 'payfail',
		component: resolve => require(['../components/view/payfail.vue'], resolve),
	}, {
		path: '/accountQuery',
		name: 'accountQuery',
		component: resolve => require(['../components/view/accountQuery.vue'], resolve),
	}, {
		path: '/arrearsDetailsOther',//其他用户缴费查询
		name: 'arrearsDetailsOther',
		component: resolve => require(['../components/view/arrearsDetailsOther.vue'], resolve),
	}, {
		path: '/paymentHistory',//缴费历史
		name: 'paymentHistory',
		component: resolve => require(['../components/view/paymentHistory.vue'], resolve),
	}, {
		path: '/accountRecharge',//账户充值
		name: 'accountRecharge',
		component: resolve => require(['../components/view/accountRecharge.vue'], resolve),
	}
	, {
		path: '/arrearsDetails1',
		name: 'arrearsDetails1',
		component: resolve => require(['../components/view/arrearsDetails1.vue'], resolve),
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js